const getYearOptions = () => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let year = currentYear; year >= 2024; year--) {
        years.push({ label: year.toString(), value: year.toString() });
    }
    return years;
};

export default getYearOptions;